'use client';

import React from 'react';

import Link from 'next/link';

import Box from '@mui/material/Box';
import MuiLink from '@mui/material/Link';
import Stack from '@mui/material/Stack';

import { SuggestedFollows } from '@/components/SuggestedFollows';
import { InfoCard } from '@/components/cards';
import { useUserInfo } from '@/context/UserInfoContext';
import { DisplayConceptRef } from '@/lib/api';
import { topic_url } from '@/lib/utils';

const HomeTopicsAndPeopleSection: React.FC = () => {
  const { userInfo, reloadUserInfo } = useUserInfo();

  if (!userInfo) {
    return null;
  }

  return (
    <Box component="section" sx={{ width: '100%', mb: 3 }} aria-labelledby="topics-and-people">
      <h2 id="topics-and-people">Topics and People</h2>
      <Stack spacing={3}>
        <InfoCard title="Followed Topics">
          {userInfo.followed_topics && userInfo.followed_topics.length > 0 ? (
            <Stack component="nav" spacing={1} aria-label="Followed topics">
              {userInfo.followed_topics.map((topic: DisplayConceptRef, index: number) => (
                <MuiLink
                  key={index}
                  component={Link}
                  href={topic_url(topic.cref)}
                  underline="none"
                  color="primary"
                >
                  {topic.display}
                </MuiLink>
              ))}
            </Stack>
          ) : (
            <p>You have no followed topics yet.</p>
          )}
        </InfoCard>

        <InfoCard title="You might also know...">
          <SuggestedFollows userInfo={userInfo} reloadUserInfo={reloadUserInfo} />
        </InfoCard>
      </Stack>
    </Box>
  );
};

export default HomeTopicsAndPeopleSection;
